import DashboardInsights from "./Insights";

export default DashboardInsights;
